import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { initTelemetry } from './utils/telemetry'

initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Si è verificato un errore imprevisto. Ricarica la pagina.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)